import { render, staticRenderFns } from "./AppMain.vue?vue&type=template&id=4850c442&scoped=true&"
import script from "./AppMain.vue?vue&type=script&lang=js&"
export * from "./AppMain.vue?vue&type=script&lang=js&"
import style0 from "./AppMain.vue?vue&type=style&index=0&id=4850c442&prod&scoped=true&lang=scss&"
import style1 from "./AppMain.vue?vue&type=style&index=1&id=4850c442&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4850c442",
  null
  
)

export default component.exports